import { render, staticRenderFns } from "./KanbanExample.vue?vue&type=template&id=43d626e0&scoped=true"
import script from "./KanbanExample.vue?vue&type=script&lang=js"
export * from "./KanbanExample.vue?vue&type=script&lang=js"
import style0 from "./KanbanExample.vue?vue&type=style&index=0&id=43d626e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d626e0",
  null
  
)

export default component.exports